import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaPlayCircle, FaPlay } from "react-icons/fa";

import videoSection from "../../../assets/student/course-video-thumb.mp4";

import "./TutorTutorial.css";

const TutorTutorial = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleCollapse = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const courseData = [
    {
      title: "01: Create Course",
    },
    {
      title: "02:  Update Course",
    },
    {
      title: "03: Upload Modules",
    },
    {
      title: "04: Create Assignment",
    },
    {
      title: "05: Student Doubts",
    },
  ];

  return (
    <Container className="tutor-tutorial-section">
      <Row>
        {/* Left Section */}
        <Col lg={9} md={12}>
          {/* <div className="tutor-tutorial-container mb-4"> */}
            <div className="tutor-tutorial-video-container">
              <video
                src={videoSection}
                controls
                controlsList="nodownload"
                disablePictureInPicture
                className="tutor-tutorial-big-video"
              />
              {/* <FaPlayCircle className="tutor-tutorial-play-icon" /> */}
            </div>
          {/* </div> */}

          <div className="tutor-tutorial-about">
            <h5 className="tutor-tutorial-about-title">Description</h5>
            <p className="tutor-tutorial-about-text">
              We believe learning should be simple, accessible, and practical.
              Skilledition, a product of Digisphere, helps students grow by
              learning coding in local languages and gaining real-time industry
              experience through internships. We believe learning should be
              simple, accessible, and practical.
            </p>
          </div>
        </Col>

        {/* Right Section */}
        <Col lg={3} md={12} className="p-0">
          <div className="tutor-tutorial-rightbox">
            <h5 className="tutor-tutorial-rightbox-title">Tutorials</h5>
            <ul className="tutor-tutorial-rightbox-list">
              {courseData.map((section, index) => (
                <li
                  key={index}
                  className="tutor-tutorial-rightbox-item"
                  onClick={() => toggleCollapse(index)}
                >
                  <span>{section.title}</span>
                  <FaPlay className="tutor-tutorial-rightbox-icon" />
                </li>
              ))}
            </ul>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default TutorTutorial;
